import { Select, Space } from 'antd'
import { useToken } from 'app/hooks'
import { useUserGroup } from 'app/hooks/user/usergroups'
import React, { useState } from 'react'
import styled from 'styled-components'

const CompactSelect = styled(Select)`
  .ant-select-selector {
    height: 28px !important;
    padding: 0 6px !important;
    font-size: 10px !important;
    line-height: 26px !important;
  }

  .ant-select-selection-item {
    font-size: 10px !important;
    line-height: 26px !important;
  }

  .ant-select-arrow {
    font-size: 8px !important;
    right: 4px !important;
  }
`

const ParentPartner = ({ data }) => {
	const { data: token } = useToken()

	const [group, setGroup] = useState<any>()

	const { type1 } = useUserGroup()

		return (
			<Space.Compact><CompactSelect
				defaultValue={data.parentid? data.parentid+'':''}
				onChange={e => {
					setGroup(e)
					data.parentid = e
				}}
				value={data.parentid? data.parentid+'':''}
				style={{
					width: '100%',
					minWidth: 100
				}}
				size="small"
				dropdownStyle={{
					fontSize: '10px'
				}}
				dropdownMatchSelectWidth={200}
				options={[
					{ value: '', label: '-' },
					...(type1 || []),
				]}
			/>
			</Space.Compact>
		)
}

export default ParentPartner
